export default __webpack_public_path__ + "static/media/tablet-light.5c9d7692.jpg";